import * as api from "app/api/workstations"
import * as notificationActions from "app/redux/notifications/notifications.actions"
import { SagaIterator } from "redux-saga"
import { call, put, takeLatest } from "redux-saga/effects"
import * as actions from "./workstations.actions"
import { handleError } from "../errorHandler/errorHandler.saga"

export function* getWorkstations(): SagaIterator {
  try {
    const response = yield call(api.getWorkstations)
    yield put(actions.getWorkstationsSuccess(response.data))
  } catch (e) {
    yield put(actions.getWorkstationsFail(e))
    yield call(handleError, { error: e })
  }
}

export function* putWorkstations(action: actions.PutWorkstationsAction): SagaIterator {
  try {
    const { data } = action.payload
    yield call(api.putWorkstations, data)
    yield put(actions.putWorkstationsSuccess())
    yield put(
      notificationActions.show({
        id: "editWorkstationSuccess",
        message: "confirmationdialog.workstation.change.message",
        variant: "success",
      }),
    )
    yield put(actions.getWorkstations())
  } catch (e) {
    yield put(actions.putWorkstationsFail(e))
    yield call(handleError, { error: e })
  }
}

export function* patchOrderWorkstations(action: actions.PatchOrderWorkstationsAction): SagaIterator {
  try {
    const { data } = action.payload
    yield call(api.patchWorkstationsOrder, data)
    yield put(actions.patchOrderWorkstationsSuccess())
    yield put(actions.getWorkstations())
  } catch (e) {
    yield put(actions.patchOrderWorkstationsFail(e))
    yield call(handleError, { error: e })
  }
}

export function* postWorkstations(action: actions.PostWorkstationsAction): SagaIterator {
  try {
    const { data } = action.payload
    const response = yield call(api.postWorkstations, data)
    yield put(actions.getWorkstations())
    yield put(actions.postWorkstationsSuccess(response.data.id))
    yield put(
      notificationActions.show({
        id: "addWorkstationSuccess",
        message: "confirmationdialog.workstation.create.message",
        variant: "success",
      }),
    )
  } catch (e) {
    yield put(actions.postWorkstationsFail(e))
    yield call(handleError, { error: e })
  }
}

export default function* workstationsSaga(): SagaIterator {
  yield takeLatest(actions.Types.GET, getWorkstations)
  yield takeLatest(actions.Types.PUT, putWorkstations)
  yield takeLatest(actions.Types.PATCH_ORDER, patchOrderWorkstations)
  yield takeLatest(actions.Types.POST, postWorkstations)
}
